import { types as t, Instance, SnapshotOut } from 'mobx-state-tree';
import WidgetModel from '~/mst/models/widget';
import NodesStore from '~/mst/models/nodes';

const ConnectivityWidgetModel = t
  .compose(
    WidgetModel,
    t.model({
      type: 'ConnectivityWidget',
      name: t.maybeNull(t.string),
      node_id: t.maybeNull(t.array(t.string)),
      nodes: t.maybeNull(NodesStore)
    })
  )
  .named('ConnectivityWidget');

export interface IConnectivityWidgetModel extends Instance<typeof ConnectivityWidgetModel> {}
export interface IConnectivityWidgetModelSnapshotOut extends SnapshotOut<typeof ConnectivityWidgetModel> {}

export default ConnectivityWidgetModel;
